import { ObjectWithId } from './../../../../util/object-with-id';
import { NodeGroup } from './node-group';
import * as TSE from 'ts-events';

export class LayoutNode extends ObjectWithId {
    public children: LayoutNode[] = [];
    public parent: LayoutNode;
    public r: number;
    public x: number;
    public y: number;
    public pixelX: number;
    public pixelY: number;
    public pixelR: number;
    public positionUpdated = new TSE.SyncEvent();
    public order: number; // optional
    public margin: number; // optional

    public addChild(c: LayoutNode) {
        this.children.push(c);
        c.parent = this;
    }
}
